import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../../api-spec";

@Component({
    selector: "app-tpa-request-export-api-manual",
    templateUrl: "../../../api-spec.html",
    styleUrls: ["../../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)]
})
export class TpaRequestExportApiManualComponent extends ApiSpecComponent {
    initSpecs(): ApiSpecificationModel {
        return <ApiSpecificationModel>{
            name: this.translation.t("specs.externalConnectionsCreateRequest"),
            description: this.translation.t("specs.externalConnectionsCreateRequestDescription"),
            httpMethod: "POST",
            path: "/thirdpartyassurance/requestexport",

            parameters: [
                {
                    name: "controlids",
                    description: this.translation.t("parameters.externalConnectionsControlidsDescription"),
                    in: "query",
                    paramType: "string",
                    required: false,
                    example: "1;2;5",
                },
                {
                    name: "testplantypes",
                    description: this.translation.t("parameters.externalConnectionsTestplantypesDescription"),
                    in: "query",
                    paramType: "string",
                    required: true,
                    example: "Effectiveness",
                    enum: ["Effectiveness"], // All and D&I will be added in the future
                },
                {
                    name: "testplanperiodstart",
                    description: this.translation.t("parameters.externalConnectionsTestplanperiodstartDescription"),
                    in: "query",
                    paramType: "date",
                    required: true,
                },
                {
                    name: "testplanperiodend",
                    description: this.translation.t("parameters.externalConnectionsTestplanperiodendDescription"),
                    in: "query",
                    paramType: "date",
                    required: true,
                },
            ],
            responses: [
                {
                    code: "200",
                    description: "OK",
                    example: "00000000-0000-0000-0000-000000000000",
                },
            ],
        };
    }
}
